/**
* [Flags]
*/
export var PickReportSource;
(function (PickReportSource) {
    PickReportSource[PickReportSource["None"] = 0] = "None";
    PickReportSource[PickReportSource["CurrentFolder"] = 2] = "CurrentFolder";
    PickReportSource[PickReportSource["DefaultFolder"] = 4] = "DefaultFolder";
    PickReportSource[PickReportSource["RootFolder"] = 8] = "RootFolder";
})(PickReportSource || (PickReportSource = {}));
;
